/** @jsx jsx */
import { useState, ChangeEvent } from 'react';
import { useTranslation } from 'react-i18next';
import NumberFormat from 'react-number-format';
import { jsx } from '@emotion/core';
import { useMediaQuery } from '@material-ui/core';

import { ICustomTheme } from 'interfaces';
import resultsIcon from 'assets/icons/declaration-form-step1.svg';
import { Overview } from '../Overview';
import { ProductsDetailsList } from 'components/ProductsDetailsList';
import {
  StyledDeclarationsText,
  StyledNumberOfDeclarations,
  StyledNumberOfDeclarationsContainer,
  StyledExpandButton,
  StyledExpandLessIcon,
  StyledExpandMoreIcon,
  StyledAccordion,
  StyledAccordionSummary,
  StyledAccordionDetails,
} from './styles';
import { TProductDetails } from 'interfaces/challenge.types';

export const OverviewOfDeclarationsAccordion = ({
  products,
  totalDeclarationQuantityPreview,
  totalDeclarationFinancialValuePreview,
  totalDeclarationRewardPreview,
  totalDeclarationResultPreview,
  displayFinancialValues,
  isGoalMecanicByProduct,
  unitToDisplay,
}: {
  products: TProductDetails[];
  totalDeclarationQuantityPreview: number;
  totalDeclarationFinancialValuePreview: number;
  totalDeclarationRewardPreview: number;
  totalDeclarationResultPreview: number;
  displayFinancialValues: boolean;
  isGoalMecanicByProduct: boolean;
  unitToDisplay: string | null;
}): JSX.Element => {
  const [isExpanded, setIsExpanded] = useState(false);
  const isMobile = useMediaQuery((theme: ICustomTheme) =>
    theme.breakpoints.down('sm'),
  );
  const { t } = useTranslation();

  const handleChange = (_: ChangeEvent<unknown>, expanded: boolean): void =>
    setIsExpanded(expanded);

  const numberOfDeclarationsSection = (
    <StyledNumberOfDeclarationsContainer>
      <StyledNumberOfDeclarations>
        <NumberFormat
          value={products.length}
          displayType="text"
          thousandSeparator=" "
        />
      </StyledNumberOfDeclarations>
      <StyledDeclarationsText>
        {t('challenges.declaration.summary.resultsStatement')}
      </StyledDeclarationsText>
    </StyledNumberOfDeclarationsContainer>
  );

  const expandArrowIcon = (
    <StyledExpandButton>
      {isExpanded ? <StyledExpandLessIcon /> : <StyledExpandMoreIcon />}
    </StyledExpandButton>
  );

  return (
    <StyledAccordion expanded={isExpanded} onChange={handleChange}>
      <StyledAccordionSummary>
        <Overview
          icon={<img src={resultsIcon} alt="results icon" />}
          title={t('challenges.declaration.summary.results')}
          statement={isMobile ? null : numberOfDeclarationsSection}
          totalDeclarationQuantityPreview={totalDeclarationQuantityPreview}
          totalDeclarationFinancialValuePreview={
            totalDeclarationFinancialValuePreview
          }
          displayFinancialValues={displayFinancialValues}
          totalDeclarationRewardPreview={totalDeclarationRewardPreview}
          totalDeclarationResultPreview={totalDeclarationResultPreview}
          expandArrowIcon={expandArrowIcon}
          isGoalMecanicByProduct={isGoalMecanicByProduct}
          unitToDisplay={unitToDisplay}
        />
      </StyledAccordionSummary>
      <StyledAccordionDetails>
        <ProductsDetailsList
          productDetailsList={products}
          unitToDisplay={unitToDisplay}
          displayFinancialValues={displayFinancialValues}
          displayGainValues
          isGoalMecanicByProduct={isGoalMecanicByProduct}
          rowsPerPage={10}
        />
      </StyledAccordionDetails>
    </StyledAccordion>
  );
};
